<template>
  <div class="w-full h-full">
    <div class="mt-10px flex flex-wrap w-full justify-between">
      <div
        v-for="(it, index) in typeList"
        :key="index"
        class="flex items-center type_item p-10px w-[calc(50%-5px)] mb-10px cursor-pointer"
        @click="openDetail(it)"
      >
        <img :src="it.img" alt="" />
        <div class="flex-1 flex justify-between flex-col items-center h-full">
          <div class="text-14px text-hex-fff text-opacity-80">{{ it.name }}</div>
          <div class="text-18px text-hex-45F2EB">{{ it.count }}</div>
        </div>
      </div>
    </div>
    <CategoryTitle title="定期检查" class="mb-5px"></CategoryTitle>
    <div class="h-[calc(55%-200px)]">
      <HistogramChart
        :regularCheckupsData="regularCheckupsOptions"
        ref="regularCheckupsChartRef"
      ></HistogramChart>
    </div>
    <div class="flex justify-between items-center">
      <CategoryTitle title="实时监测"></CategoryTitle>
      <!-- <TableButtonGroup :list="tabList" v-model="tabName" class="my-10px" @btn-click="tabClick" /> -->
    </div>
    <div class="h-1/5">
      <PieChart
        :realtimeMonitoringData="realtimeMonitoringOptions"
        ref="realtimeMonitoringRef"
      ></PieChart>
    </div>
    <InfiniteScroll
      :deviation="10"
      class="h-1/4 overflow-hidden"
      direction="Y"
      :limit="3"
      :num="alarmList.length"
      :speed="0.5"
      ref="infiniteScrollRef"
      @reset="resetScrollHeight"
      v-if="alarmList.length"
    >
      <div class="w-full">
        <div v-for="(it, index) in alarmList" :key="index" @click="errorClick(it)">
          <div
            class="flex items-center border-1px border-hex-881919 p-5px bg-hex-741717 bg-opacity-30 mt-10px hover:cursor-pointer"
          >
            <div
              class="alarm_bg text-12px w-44px h-36px flex justify-center items-center text-center flex-wrap"
            >
              <span class="alarm_name alarmsTitle leading-14px">{{ it.alarmTypeName }}</span>
            </div>
            <div class="pl-10px text-hex-fff truncate flex-1">{{ it.alarmName }}</div>
          </div>
        </div>
      </div>
    </InfiniteScroll>

    <!-- 巡检异常弹框 -->
    <dialogError class="w-1000px h-500px" v-if="showADialogError" :tabType="errorDataType" @close="closeError" :errorData="errorData"></dialogError>
  </div>
</template>

<script>
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import { ViewRecordApi, AlarmModelApi } from '@wiz-api/huizhou2'
import { DeviceAlarmApi } from '@wiz-api/large-screen-management'
import dayjs from 'dayjs'
import { WizboxListingApi } from '@wiz-api/data-box'

const alarmModelApi = new AlarmModelApi()
const viewRecordApi = new ViewRecordApi()
const deviceAlarmApi = new DeviceAlarmApi()
const wizboxListingApi = new WizboxListingApi()
const InfiniteScroll = () => {
  return import('./components/InfiniteScroll')
}
const HistogramChart = () => {
  return import('./components/HistogramChart')
}
const PieChart = () => {
  return import('./components/PieChart')
}
const dialogError = () => {
  return import('../../../../cockpit-huizhou/components/IntelligentPowerGeneration/dialogError')
}
export default {
  props: {},
  components: { CategoryTitle, InfiniteScroll, HistogramChart, PieChart, dialogError },
  data() {
    return {
      typeList: [
        {
          img: require('../../../assets/images/inspectionAPicture/inspetction_robot.png'),
          name: '巡检机器人',
          count: '',
          prop: '',
          code: 'RobotList',
          codeName: '巡检机器人清单',
          deviceType: '机器人巡检',
        },
        {
          img: require('../../../assets/images/inspectionAPicture/inspetction_AI.png'),
          name: 'AI视频识别',
          count: '',
          prop: '',
          code: 'VideoRecognitionList',
          codeName: '视频识别清单',
          deviceType: 'AI 视频识别',
        },
        {
          img: require('../../../assets/images/inspectionAPicture/inspetction_sensor.png'),
          name: '智能传感器',
          count: '',
          prop: '',
          code: 'SensorList',
          codeName: '智能传感器清单',
          deviceType: '智能传感器',
        },
        {
          img: require('../../../assets/images/inspectionAPicture/inspetction_site.png'),
          name: '点巡检站点',
          count: '',
          prop: '',
          code: 'PointList',
          codeName: '巡检点位清单',
          deviceType: '点巡检',
        },
      ],
      alarmList: [],
      tabList: ['日', '周', '月'],
      currenType: 1,
      tabName: '日',
      timer: null,
      regularCheckupsOptions: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          data: ['巡检次数'],
          itemWidth: 14,
          itemHeight: 10,
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
        },
        grid: {
          top: '15%',
          left: '10%',
          right: '10%',
          bottom: 20,
        },
        xAxis: {
          type: 'category',
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.85)',
            fontSize: 12,
          },
          splitLine: {
            show: false,
          },
          data: [],
        },
        yAxis: {
          type: 'value',
          name: '',
          nameTextStyle: { color: '#fff' },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.15)',
              width: 1,
            },
          }, // 去除网格线
          axisLine: {
            show: false,
          },
          axisTick: { show: false },
          axisLabel: {
            margin: 2,
            interval: 10,
            color: 'rgba(255, 255, 255, 0.85)',
          },
          minInterval: 1,
        },
        series: [
          {
            name: '巡检次数',
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              // 设置柱状图的颜色
              color: '#009DFF',
            },
            data: [],
          },
        ],
      },
      realtimeMonitoringOptions: {
        color: ['#45f2eb', '#3cd495', '#75c7ff', '#ebc541'],
        tooltip: {
          trigger: 'item',
        },
        legend: {
          x: '55%', // 可设定图例在左、右、居中
          y: 'center', // 可设定图例在上、下、居中
          align: 'left', // 字在图例的左边或右边【left/right】
          orient: 'vertical', // 图例方向【horizontal/vertical】
          itemWidth: 8,
          itemHeight: 8,
          icon: 'rect', // 图例形状【circle\rect\roundRect\triangle\diamond\pin\arrow\none】
          itemGap: 16,
          textStyle: {
            rich: {
              name: {
                color: 'rgba(255,255,255,0.7)',
                fontSize: 12,
                width: 90,
              },
              value: {
                color: 'rgba(255,255,255,1)',
                fontSize: 12,
                width: 90,
              },
            },
          },
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: [0, 60],
            center: ['30%', '50%'],
            label: {
              normal: {
                show: false,
                position: 'inside',
                formatter: '{b}',
                textStyle: {
                  align: 'center',
                  baseline: 'middle',
                  fontSize: 16,
                  fontWeight: '100',
                  color: '#fff',
                },
              },
            },
            itemStyle: {
              borderWidth: 4,
              borderColor: '#10393b',
            },
            labelLine: {
              show: true,
            },
            data: [],
          },
        ],
      },
      showADialogError: false,
      errorDataType: 0,
      errorData: {},
    }
  },
  computed: {
    showScrollAreaData() {
      return this.alarmList.length > 3
    },
  },
  methods: {
    resetScrollHeight() {
      this.$refs.infiniteScrollRef.height = 0
    },
    // async tabClick(value) {
    //   switch (value) {
    //     case '周':
    //       this.currenType = 2
    //       break
    //     case '日':
    //       this.currenType = 1
    //       break
    //     case '月':
    //       this.currenType = 3
    //       break
    //     default:
    //       break
    //   }
    //   this.getPieData()
    // },
    openDetail(value) {
      this.$emit('transferEvent', {
        toCom: { code: value.code, origin: 'InspectionAPicture', name: value.codeName },
        type: 'mainComponent',
        props: {},
      })
    },
    // showRecording() {
    //   this.$nextTick(() => {
    //     setTimeout(() => {
    //       this.$refs.regularCheckupsChartRef.$refs.histogramChartRef.chart
    //         .getZr()
    //         .on('click', this.openRecording)
    //     }, 900)
    //   })
    // },
    // openRecording(params) {
    //   const currIndex = [params.event.offsetX, params.event.offsetY]
    //   let time = ''
    //   if (
    //     this.$refs.regularCheckupsChartRef.$refs.histogramChartRef.containPixel('grid', currIndex)
    //   ) {
    //     const index = this.$refs.regularCheckupsChartRef.$refs.histogramChartRef.convertFromPixel(
    //       { seriesIndex: 0 },
    //       currIndex
    //     )
    //     const xIndex = index[0]
    //     time = this.regularCheckupsOptions.xAxis[0].data[xIndex]
    //   }
    //   const paramsTime = `${dayjs().format('YYYY')}-${time} 00:00:00`
    //   if (time) {
    //     this.$emit('transferEvent', {
    //       toCom: { code: 'Recording', origin: 'InspectionAPicture', name: '巡检记录' },
    //       type: 'mainComponent',
    //       props: {
    //         time: paramsTime,
    //       },
    //     })
    //     this.$nextTick(() => {
    //       setTimeout(() => {
    //         const openEvent = new CustomEvent('recordingProps', {
    //           detail: {
    //             paramsTime,
    //           },
    //         })
    //         window.dispatchEvent(openEvent)
    //       }, 1000)
    //     })
    //   }
    // },
    // openExceptionLogList(params) {
    //   const index = params?.target?.dataIndex
    //   if (index || index === 0) {
    //     this.$emit('transferEvent', {
    //       toCom: { code: 'Abnormal', origin: 'InspectionAPicture', name: '异常记录' },
    //       type: 'mainComponent',
    //       props: {},
    //     })
    //     this.$nextTick(() => {
    //       setTimeout(() => {
    //         const openEvent = new CustomEvent('pieChartProps', {
    //           detail: {
    //             params: this.realtimeMonitoringOptions.series[0].data[index],
    //           },
    //         })
    //         window.dispatchEvent(openEvent)
    //       }, 1000)
    //     })
    //   }
    // },
    // showAbnormal() {
    //   this.$nextTick(() => {
    //     setTimeout(() => {
    //       this.$refs.realtimeMonitoringRef.$refs.pieChartRef.chart
    //         .getZr()
    //         .on('click', this.openExceptionLogList)
    //     }, 900)
    //   })
    // },
    // 获取报警数据
    async getAlarmData() {
      const [err, res] = await deviceAlarmApi.getAlarms()
      if (!err) {
        this.alarmList = res
      }
    },
    // 获取柱状图数据
    async getHistogramData() {
      const startTime = dayjs().subtract(6, 'day').format('YYYY-MM-DD HH:mm:ss')
      const endTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      const [err, res] = await viewRecordApi.getDailyViewRecordCounts({ startTime, endTime })
      if (!err) {
        this.regularCheckupsOptions.xAxis.data = res.map((it) => {
          return dayjs(it._date).format('MM-DD')
        })
        this.regularCheckupsOptions.series[0].data = res.map((it) => {
          return it.robotRecordCount
        })
        // this.showRecording()
      }
    },
    // 获取饼图数据
    async getPieData() {
      const [err, res] = await deviceAlarmApi.getAlarmStatistics({
        filterPlantUnit: false
      })
      if (!err) {
        const seriesData = res.map((it) => {
          return { value: it.count, name: it.alarmType }
        })
        this.realtimeMonitoringOptions.series[0].data = seriesData
        this.realtimeMonitoringOptions.legend.formatter = (name) => {
          const item = seriesData.filter((it) => {
            return it.name === name
          })[0]
          return `{name|${name}}{value| ${item.value}}`
        }
        // this.showAbnormal()
      }
    },
    // 获取在线数据
    async getDeviceStatistics() {
      const [err, res] = await alarmModelApi.getDeviceStatisticsItems()
      if (!err) {
        res.forEach((item) => {
          if (item.deviceType === '机器人巡检') {
            this.typeList[0].count = item.totalDevices
          } else if (item.deviceType === 'AI 视频识别') {
            this.typeList[1].count = item.totalDevices
          } else if (item.deviceType === '点巡检') {
            this.typeList[3].count = item.totalDevices
          }
        })
      }
    },
    // 获取传感器数量
    async getSensorCount() {
      const [err, res] = await wizboxListingApi.findAllUsingGET1({
        // boxStatus: 0,
        pageNo: 1,
        pageSize: 1
      })
      if (!err) {
        this.typeList[2].count = res.page.pageTotal
      }
    },
    closeError() {
      this.showADialogError = false
    },
    errorClick(item) {
      const type = new Map([
        ['设备诊断', 0],
        ['机器人巡检', 1],
        ['智能AI+算法分析', 2],
      ])
      this.errorDataType = type.get(item.alarmTypeName) ?? 0
      this.errorData = item
      this.showADialogError = true
    },
  },
  created() {
    this.getAlarmData()
    this.getDeviceStatistics()
    this.getSensorCount()
  },
  mounted() {
    this.getHistogramData()
    this.getPieData()
    const data = this.realtimeMonitoringOptions.series[0].data
    this.realtimeMonitoringOptions.legend.formatter = (name) => {
      const item = data.filter((it) => {
        return it.name === name
      })[0]
      return `{name|${name}}{value| ${item.value}}`
    }
    this.timer = setInterval(() => {
      this.getAlarmData()
    }, 60000)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>
.type_item {
  background-image: url('../../../assets/images/inspectionAPicture/inspetction_typeTab_bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.alarm_bg {
  background-image: url('../../../assets/images/inspectionAPicture/alarm_bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.alarm_name {
  background: -webkit-linear-gradient(180deg, #ffffff 0%, #ff9797 100%);
  background: linear-gradient(180deg, #ffffff 0%, #ff9797 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}
.alarmsTitle {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
